import {
  labNotebookFieldLabels,
  LabNotebookFiltersTranslator,
  labNoteBooksConstants,
  LabNotebookSortingOptionsConsts,
} from "../ELN/types/LabNotebook";
import {
  labNotebookEntriesConstants,
  labNotebookEntryFieldLabels,
  LabNotebookEntryFiltersTranslator,
  LabNotebookEntrySortingOptionsConsts,
} from "../ELN/types/LabNotebookEntry";
import {
  labNotebookExperimentFieldLabels,
  LabNotebookExperimentFiltersTranslator,
  labNotebookExperimentsConstants,
  LabNotebookExperimentSortingOptionsConsts,
} from "../ELN/types/LabNotebookExperiment";
import {
  labNotebookTemplateFieldLabels,
  LabNotebookTemplateFiltersTranslator,
  labNotebookTemplatesConstants,
  LabNotebookTemplateSortingOptionsConsts,
} from "../ELN/types/LabNotebookTemplate";
import {
  AnnouncementFieldLabels,
  AnnouncementFiltersTranslator,
  announcementsConstants,
  AnnouncementSortingOptionsConsts,
} from "./Announcements";
import { ApiKeyFieldLabels, apiKeysConstants } from "./ApiKey";
import {
  auditLogConstants,
  AuditLogFieldLabels,
  AuditLogFiltersTranslator,
  AuditLogSortingOptionsConsts,
} from "./AuditLog";
import { bridgeConstants, BridgeFieldLabels, BridgeFiltersTranslator, BridgeSortingOptionsConsts } from "./Bridges";
import {
  customFieldConstants,
  CustomFieldSortingOptionsConsts,
  CustomFieldFiltersTranslator,
  CustomFieldFieldLabels,
} from "./CustomFields/CustomFields";
import {
  customImportConstants,
  CustomImportFieldLabels,
  CustomImportFiltersTranslator,
  customImportLogConstants,
  CustomImportLogFieldLabels,
  CustomImportLogFiltersTranslator,
  CustomImportLogSortingOptionsConsts,
  CustomImportSortingOptionsConsts,
} from "./CustomImports";
import {
  customTypeConstants,
  CustomTypeSortingOptionsConsts,
  CustomTypeFiltersTranslator,
  CustomTypeFieldLabels,
} from "./CustomTypes/CustomTypes";
import {
  AttachmentFieldLabels,
  DatasetFieldLabels,
  DatasetFiltersTranslator,
  datasetsConstants,
  DatasetSortingOptionsConsts,
} from "./Datasets";
import {
  dataSourceConstants,
  DataSourceSortingOptionsConsts,
  DataSourceFiltersTranslator,
  DataSourceFieldLabels,
} from "./DataSource";
import {
  dataSourceStatusConstants,
  DataSourceStatusSortingOptionsConsts,
  DataSourceStatusFiltersTranslator,
  DataSourceStatusFieldLabels,
} from "./DataSourceStatus";
import {
  inventoriesConstants,
  InventoryItemFieldLabels,
  InventoryItemFiltersTranslator,
  inventoryItemsConstants,
  InventoryItemSortingOptionsConsts,
} from "./Inventories";
import { attachmentsConstants } from "./Attachments";
import { personsConstants, PersonSortingOptionsConsts, PersonFiltersTranslator, PersonFieldLabels } from "./Person";
import {
  projectsConstants,
  ProjectSortingOptionsConsts,
  ProjectFiltersTranslator,
  ProjectFieldLabels,
} from "./Projects";
import { rolesConstants, RoleSortingOptionsConsts, RoleFiltersTranslator, RoleFieldLabels } from "./Role";
import { samplesConstants, SampleSortingOptionsConsts, SampleFiltersTranslator, SampleFieldLabels } from "./Samples";
import {
  sharedContentConstants,
  SharedContentSortingOptionsConsts,
  SharedContentFiltersTranslator,
  SharedContentFieldLabels,
} from "./SharedContent";
import { vendorsConstants, VendorSortingOptionsConsts, VendorFiltersTranslator, VendorFieldLabels } from "./Vendors";
import { EntityConstants, GenericEntity, IListRequestParameters } from "./GenericTypes";
import {
  IconNMRHistoryEntrySortingOptionsConsts,
  IconNMRHistoryEntryFiltersTranslator,
  IconNMRHistoryFieldLabels,
  iconNMRHoldersConstants,
  IconNMRHolderSortingOptionsConsts,
  IconNMRHolderFiltersTranslator,
  IconNMRHolderFieldLabels,
  iconNMRHistoryConstants,
} from "./IconNMR";
import { MethodFieldLabels, MethodFiltersTranslator, methodsConstants, MethodSortingOptionsConsts } from "./Method";
import {
  customTypeTemplateConstants,
  CustomTypeTemplateFieldLabels,
  CustomTypeTemplateFiltersTranslator,
  CustomTypeTemplateSortingOptionsConsts,
} from "./CustomTypes/CustomTypeTemplates";
import {
  customTypeTemplatePackageConstants,
  CustomTypeTemplatePackageFieldLabels,
  CustomTypeTemplatePackageFiltersTranslator,
  CustomTypeTemplatePackageSortingOptionsConsts,
} from "./CustomTypes/CustomTypeTemplatePackages";
import {
  DataFormatFieldLabels,
  DataFormatFiltersTranslator,
  dataFormatsConstants,
  DataFormatSortingOptionsConsts,
} from "./DataFormats";
import {
  FileExportJobFieldLabels,
  FileExportJobFiltersTranslator,
  fileExportJobsConstants,
  FileExportJobSortingOptionsConsts,
} from "./FileExportJobs";
import {
  customFieldTemplateConstants,
  CustomFieldTemplateFiltersTranslator,
  CustomFieldTemplateLabels,
  CustomFieldTemplateSortingOptionsConsts,
} from "./CustomFields/CustomFieldTemplates";
import {
  zontalCredentialsConstants,
  ZontalCredentialsFieldLabels,
  ZontalInformationPackageProfileFieldLabels,
  ZontalInformationPackageProfileFiltersTranslator,
  ZontalInformationPackageSortingOptionsConsts,
  zontalIPPConstants,
} from "./Zontal";

// Main types
export type GenericEntityConstantsEntities = keyof typeof genericEntityConstants;
export type GenericEntityConstants = typeof genericEntityConstants;
export type GenericEntityConstant<EntityTypeId extends GenericEntityConstantsEntities> =
  (typeof genericEntityConstants)[EntityTypeId];

// This helper function returns the correctly typed entity constants for a given entity type.
/**
 * Retrieves the constants associated with a specific entity type.
 * @author @CorradoSurmanowicz
 * @template T - The key type of the GenericEntityConstants.
 * @param entityTypeId - The identifier of the entity type for which to retrieve constants.
 * @returns The constants associated with the specified entity type.
 */
export const getEntityConstants = <EntityTypeId extends GenericEntityConstantsEntities>(entityTypeId: EntityTypeId) => {
  return genericEntityConstants[entityTypeId];
};

/**
 * Represents the entity associated with a specific entity type ID.
 * @author @CorradoSurmanowicz
 * @template EntityTypeId - A type that extends `GenericEntityConstantsEntities`.
 */
export type EntityByEntityTypeId<EntityTypeId extends GenericEntityConstantsEntities> = InferEntity<
  GenericEntityConstant<EntityTypeId>["entityConstants"]
> &
  GenericEntity;

// export type FiltersByEntityTypeId<EntityTypeId extends GenericEntityConstantsEntities> = InferFilters<
//   GenericEntityConstant<EntityTypeId>["entityConstants"]
// >

/**
 * Infers the key of `genericEntityConstants` (EntityTypeId) by the entity type of `entityConstants`.
 * @author @CorradoSurmanowicz
 * @template Entity - The entity type to match.
 */
export type EntityTypeIdByEntity<Entity extends GenericEntity> = {
  [K in keyof typeof genericEntityConstants]: InferEntity<
    (typeof genericEntityConstants)[K]["entityConstants"]
  > extends Entity
    ? K
    : never;
}[keyof typeof genericEntityConstants];

/**
 * Represents the filters associated with a specific entity type ID.
 * @author @CorradoSurmanowicz
 * @template EntityTypeId - A type that extends `GenericEntityConstantsEntities`.
 *
 * This type combines the inferred filters from the entity constants of the given entity type ID
 * with the request parameters for a list, including the inferred order by parameters.
 */
export type FiltersByEntityTypeId<EntityTypeId extends GenericEntityConstantsEntities> = InferFilters<
  GenericEntityConstant<EntityTypeId>["entityConstants"]
> &
  IListRequestParameters<InferOderBy<InferFilters<GenericEntityConstant<EntityTypeId>["entityConstants"]>>>;

/**
 * Constants object that stores entity constants, sorting options, filters translators, and field labels for various entities.
 *
 * @remarks
 * This object is used to define and access constants related to different entities in the application.
 * Each entity has its own set of entity constants, sorting options, filters translators, and field labels.
 *
 * @author @CorradoSurmanowicz
 * @example
 * ```typescript
 * const entity = genericEntityConstants.Announcements;
 * console.log(entity.entityConstants); // Output: announcementsConstants
 * console.log(entity.sortingOptions); // Output: AnnouncementSortingOptionsConsts
 * console.log(entity.filtersTranslator); // Output: AnnouncementFiltersTranslator
 * console.log(entity.fieldLabels); // Output: AnnouncementFieldLabels
 * ```
 */

// Todo:
// Migrate all entities to use fieldLabels
// Add views property: DetailTable, Preview (optional), Filters, QuickForms, Dropdowns, ContentRow, EntityTiles

export const genericEntityConstants = Object.freeze({
  announcements: {
    entityConstants: announcementsConstants,
    sortingOptions: AnnouncementSortingOptionsConsts,
    filtersTranslator: AnnouncementFiltersTranslator,
    fieldLabels: AnnouncementFieldLabels,
  },
  apiKeys: {
    entityConstants: apiKeysConstants,
    sortingOptions: [],
    filtersTranslator: {},
    fieldLabels: ApiKeyFieldLabels,
  },
  attachments: {
    entityConstants: attachmentsConstants,
    sortingOptions: DatasetSortingOptionsConsts,
    filtersTranslator: DatasetFiltersTranslator,
    fieldLabels: AttachmentFieldLabels,
  },
  auditLogs: {
    entityConstants: auditLogConstants,
    sortingOptions: AuditLogSortingOptionsConsts,
    filtersTranslator: AuditLogFiltersTranslator,
    fieldLabels: AuditLogFieldLabels,
  },
  bridges: {
    entityConstants: bridgeConstants,
    sortingOptions: BridgeSortingOptionsConsts,
    filtersTranslator: BridgeFiltersTranslator,
    fieldLabels: BridgeFieldLabels,
  },
  customFields: {
    entityConstants: customFieldConstants,
    sortingOptions: CustomFieldSortingOptionsConsts,
    filtersTranslator: CustomFieldFiltersTranslator,
    fieldLabels: CustomFieldFieldLabels,
  },
  customImports: {
    entityConstants: customImportConstants,
    sortingOptions: CustomImportSortingOptionsConsts,
    filtersTranslator: CustomImportFiltersTranslator,
    fieldLabels: CustomImportFieldLabels,
  },
  customImportLogs: {
    entityConstants: customImportLogConstants,
    sortingOptions: CustomImportLogSortingOptionsConsts,
    filtersTranslator: CustomImportLogFiltersTranslator,
    fieldLabels: CustomImportLogFieldLabels,
  },
  customTypeTemplates: {
    entityConstants: customTypeTemplateConstants,
    sortingOptions: CustomTypeTemplateSortingOptionsConsts,
    filtersTranslator: CustomTypeTemplateFiltersTranslator,
    fieldLabels: CustomTypeTemplateFieldLabels,
  },
  customFieldTemplates: {
    entityConstants: customFieldTemplateConstants,
    sortingOptions: CustomFieldTemplateSortingOptionsConsts,
    filtersTranslator: CustomFieldTemplateFiltersTranslator,
    fieldLabels: CustomFieldTemplateLabels,
  },
  customTypeTemplatePackages: {
    entityConstants: customTypeTemplatePackageConstants,
    sortingOptions: CustomTypeTemplatePackageSortingOptionsConsts,
    filtersTranslator: CustomTypeTemplatePackageFiltersTranslator,
    fieldLabels: CustomTypeTemplatePackageFieldLabels,
  },
  customTypes: {
    entityConstants: customTypeConstants,
    sortingOptions: CustomTypeSortingOptionsConsts,
    filtersTranslator: CustomTypeFiltersTranslator,
    fieldLabels: CustomTypeFieldLabels,
  },
  datasets: {
    entityConstants: datasetsConstants,
    sortingOptions: DatasetSortingOptionsConsts,
    filtersTranslator: DatasetFiltersTranslator,
    fieldLabels: DatasetFieldLabels,
  },
  dataFormats: {
    entityConstants: dataFormatsConstants,
    sortingOptions: DataFormatSortingOptionsConsts,
    filtersTranslator: DataFormatFiltersTranslator,
    fieldLabels: DataFormatFieldLabels,
  },
  dataSources: {
    entityConstants: dataSourceConstants,
    sortingOptions: DataSourceSortingOptionsConsts,
    filtersTranslator: DataSourceFiltersTranslator,
    fieldLabels: DataSourceFieldLabels,
  },
  dataSourceStatus: {
    entityConstants: dataSourceStatusConstants,
    sortingOptions: DataSourceStatusSortingOptionsConsts,
    filtersTranslator: DataSourceStatusFiltersTranslator,
    fieldLabels: DataSourceStatusFieldLabels,
  },
  fileExportJobs: {
    entityConstants: fileExportJobsConstants,
    sortingOptions: FileExportJobSortingOptionsConsts,
    filtersTranslator: FileExportJobFiltersTranslator,
    fieldLabels: FileExportJobFieldLabels,
  },
  iconNMRHistoryEntry: {
    entityConstants: iconNMRHistoryConstants,
    sortingOptions: IconNMRHistoryEntrySortingOptionsConsts,
    filtersTranslator: IconNMRHistoryEntryFiltersTranslator,
    fieldLabels: IconNMRHistoryFieldLabels,
  },
  iconNMRHolders: {
    entityConstants: iconNMRHoldersConstants,
    sortingOptions: IconNMRHolderSortingOptionsConsts,
    filtersTranslator: IconNMRHolderFiltersTranslator,
    fieldLabels: IconNMRHolderFieldLabels,
  },
  inventories: {
    entityConstants: inventoriesConstants,
    sortingOptions: CustomTypeSortingOptionsConsts,
    filtersTranslator: CustomTypeFiltersTranslator,
    fieldLabels: CustomTypeFieldLabels,
  },
  inventoryItems: {
    entityConstants: inventoryItemsConstants,
    sortingOptions: InventoryItemSortingOptionsConsts,
    filtersTranslator: InventoryItemFiltersTranslator,
    fieldLabels: InventoryItemFieldLabels,
  },
  notebooks: {
    entityConstants: labNoteBooksConstants,
    sortingOptions: LabNotebookFiltersTranslator,
    filtersTranslator: LabNotebookSortingOptionsConsts,
    fieldLabels: labNotebookFieldLabels,
  },
  notebookExperiments: {
    entityConstants: labNotebookExperimentsConstants,
    sortingOptions: LabNotebookExperimentSortingOptionsConsts,
    filtersTranslator: LabNotebookExperimentFiltersTranslator,
    fieldLabels: labNotebookExperimentFieldLabels,
  },
  notebookEntries: {
    entityConstants: labNotebookEntriesConstants,
    sortingOptions: LabNotebookEntrySortingOptionsConsts,
    filtersTranslator: LabNotebookEntryFiltersTranslator,
    fieldLabels: labNotebookEntryFieldLabels,
  },
  notebookTemplates: {
    entityConstants: labNotebookTemplatesConstants,
    sortingOptions: LabNotebookTemplateSortingOptionsConsts,
    filtersTranslator: LabNotebookTemplateFiltersTranslator,
    fieldLabels: labNotebookTemplateFieldLabels,
  },
  methods: {
    entityConstants: methodsConstants,
    sortingOptions: MethodSortingOptionsConsts,
    filtersTranslator: MethodFiltersTranslator,
    fieldLabels: MethodFieldLabels,
  },
  persons: {
    entityConstants: personsConstants,
    sortingOptions: PersonSortingOptionsConsts,
    filtersTranslator: PersonFiltersTranslator,
    fieldLabels: PersonFieldLabels,
  },
  projects: {
    entityConstants: projectsConstants,
    sortingOptions: ProjectSortingOptionsConsts,
    filtersTranslator: ProjectFiltersTranslator,
    fieldLabels: ProjectFieldLabels,
  },
  roles: {
    entityConstants: rolesConstants,
    sortingOptions: RoleSortingOptionsConsts,
    filtersTranslator: RoleFiltersTranslator,
    fieldLabels: RoleFieldLabels,
  },
  samples: {
    entityConstants: samplesConstants,
    sortingOptions: SampleSortingOptionsConsts,
    filtersTranslator: SampleFiltersTranslator,
    fieldLabels: SampleFieldLabels,
  },
  sharedContents: {
    entityConstants: sharedContentConstants,
    sortingOptions: SharedContentSortingOptionsConsts,
    filtersTranslator: SharedContentFiltersTranslator,
    fieldLabels: SharedContentFieldLabels,
  },
  vendors: {
    entityConstants: vendorsConstants,
    sortingOptions: VendorSortingOptionsConsts,
    filtersTranslator: VendorFiltersTranslator,
    fieldLabels: VendorFieldLabels,
  },
  zontalCredentials: {
    entityConstants: zontalCredentialsConstants,
    sortingOptions: [],
    filtersTranslator: {},
    fieldLabels: ZontalCredentialsFieldLabels,
  },
  zontalIPP: {
    entityConstants: zontalIPPConstants,
    sortingOptions: ZontalInformationPackageSortingOptionsConsts,
    filtersTranslator: ZontalInformationPackageProfileFiltersTranslator,
    fieldLabels: ZontalInformationPackageProfileFieldLabels,
  },
} as const);

// Utility types

/**
 * Infers the entity type `T` from a given `EntityConstants` type `S`.
 * If `S` extends `EntityConstants` with some type `T` and any other type,
 * this utility type extracts and returns `T`. Otherwise, it returns `never`.
 * @author @CorradoSurmanowicz
 * @template S - The type from which to infer the entity type.
 */
export type InferEntity<S> = S extends EntityConstants<infer T, any> ? T : never;
/**
 * Infers the filter type `T` from an `EntityConstants` type.
 * @author @CorradoSurmanowicz
 * @template S - The type to infer from.
 * @returns The inferred filter type `T` if `S` extends `EntityConstants<any, T>`, otherwise `never`.
 */
export type InferFilters<S> = S extends EntityConstants<any, infer T> ? T : never;

type InferOderBy<S> = S extends IListRequestParameters<infer O> ? O : never;
